import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import ChannelIcon from 'src/components/ChannelIcon';
import { TruncatedTypography } from 'src/components/TruncatedTypography';
import { CHANNEL, getChannelPerformanceLabel } from 'src/data/channel';
import { useStyles } from './useStyles';
import { getResourceDocumentLabel } from 'src/data/performance';
import { TYPOGRAPHY_VARIANT } from '../CustomTypography';

export const ChannelItem = memo(({ className, classes, channel, accountLabel, channelLabel }) => {
  const styles = useStyles({ classes });

  const label = getChannelPerformanceLabel(channel) || getResourceDocumentLabel(channel);

  return (
    <div className={cx(styles.root, className)}>
      <ChannelIcon
        className={styles.icon}
        channel={channel}
        meta
      />
      <div>
        <TruncatedTypography
          className={styles.label}
          variant={TYPOGRAPHY_VARIANT.regular14}
        >
          {accountLabel || label}
        </TruncatedTypography>
        {channelLabel && (
          <TruncatedTypography
            className={styles.channelLabel}
            variant={TYPOGRAPHY_VARIANT.regular12}
          >
            {channelLabel}
          </TruncatedTypography>
        )}
      </div>
    </div>
  );
});

ChannelItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  channel: PropTypes.oneOf(Object.values(CHANNEL)).isRequired,
  accountLabel: PropTypes.string,
  channelLabel: PropTypes.string,
};

ChannelItem.defaultProps = {
  className: '',
  classes: null,
  accountLabel: null,
  channelLabel: null,
};
